import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9.108 22.092L2 19.721V3.61303L8.892 5.91303L15.923 1.89203L22 4.32303V20.477L16.077 18.107L9.109 22.092H9.108ZM4 6.39203V18.279L8 19.612V7.72003L4 6.39203ZM14 5.29203L10 7.58003V19.28L14 16.992V5.29203ZM16.077 4.10603L16 4.15203V15.923L20 17.523V5.67603L16.077 4.10603Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Map"
);
